<template>
  <div class="legal-container">
    <div class="menu-links">
      <a class="menu-item active-menu" href="/legal/legal">General Terms</a>
      <a class="menu-item" href="/legal/privacy">Privacy Policy</a>
      <a class="menu-item" target="_blank" href="/static/hellopeter_paia_manual.pdf">PAIA Manual</a>
    </div>
    <h3 class="has-text-weight-bold">General Terms</h3>
    <p>These terms and conditions (the "Terms") govern your access to and use of Hellopeter's websites and mobile applications that link to or reference these Terms ("Site"). By accessing or using the
      Site, you are agreeing to these Terms and concluding a legally binding contract with TKJ Design (Pty) Ltd trading as Hellopeter.com, a company registered in accordance with the laws of the Republic of South Africa ("Hellopeter"). Do
      not access or use the Site if you are unwilling or unable to be bound by the Terms.</p>
    <div class="columns legal-columns">
      <!-- LEFT PANEL -->
      <div class="column is-one-third-tablet">
        <nav class="grid__1-4th--md legal-menu">
          <div class="bg-grey p-3">
            <ol class="list--silent text-muted">
              <li><a href="#section1">Definitions</a></li>
              <li><a href="#section2">Consumer Protection Act</a></li>
              <li><a href="#section3">Electronic Communications and Transactions Act</a></li>
              <li><a href="#section4">Changes to the Terms of Service</a></li>
              <li><a href="#section5">Using the Site</a></li>
              <li><a href="#section6">Content</a></li>
              <li><a href="#section7">Restrictions</a></li>
              <li><a href="#section8">Guidelines and Policies</a></li>
              <li><a href="#section9">Subscriptions</a></li>
              <li><a href="#section11">Conflict with Other Terms</a></li>
              <li><a href="#section12">Suggestions and Improvements</a></li>
              <li><a href="#section13">Third Parties</a></li>
              <li><a href="#section14">Indemnity</a></li>
              <li><a href="#section15">Disclaimers and Limitations of Liability</a></li>
              <li><a href="#section16">Choice of Law and Venue</a></li>
              <li><a href="#section17">Termination</a></li>
              <li><a href="#section18">Notices</a></li>
              <li><a href="#section19">General Terms</a></li>
            </ol>
          </div>
        </nav>
      </div>
      <div class="column legal-content">
        <ol>

          <li id="section1" class="legal-head">Definitions

            <ol>

              <li>Parties
                <ol>
                  <li>"You" and "Your" refer to you, as a User of the Site, whether or not a Registered User;
                  </li>
                  <li>“Registered User” is a User who has opened an account on the Site.</li>
                  <li>"User" is someone who accesses, browses, crawls, scrapes, or in any way uses the Site and includes a reviewer or a business.
                  </li>
                  <li>"We, "Us" and "Our" refer to TKJ Design (Pty) Ltd trading as Hellopeter.com.</li>
                  <li>“reviewer” means a consumer that posts a review on the Site.</li>
                  <li>“business” means a business that is the subject matter of a review on the Site or who purchases a Subscription for a business.</li>
                </ol>
              </li>

              <li>Content

                <ol>
                  <li>"Content" means text, images, photos, audio, video, location data, and all other forms of data or communication.
                  </li>
                  <li>“Content Guidelines” means the guidelines referred to in clause 6 (Content).</li>
                  <li>“Your Content" means Content that you submit or transmit to, through, or in connection with the Site, such as complaints, postings, reviews, compliments, replies, responses, messages, and any other information about
                    yourself that you elect may be publicly displayed on the Site. In the case of businesses, Your Content includes your trademarks, tradename, logo’s and other information (including location and contact details) that you
                    elect may be publicly displayed on the Site.
                  </li>
                  <li>"User Content" means Content that Users submit or transmit to, through, or in connection with the Site, but excludes any advertising on the Site.
                  </li>
                  <li>"Hellopeter Content" means Content that we create and make available in connection with the Site.
                  </li>
                  <li>"Third Party Content" means Content that originates from parties other than Hellopeter or its Users, which is made available in connection with the Site.
                  </li>
                  <li>"Site Content" means all of the Content that is made available in connection with the Site, including Your Content, User Content, Third Party Content, and Hellopeter Content.
                  </li>
                </ol>
              </li>

              <li>Other

                <ol>
                  <li>“Applicable Law” means the law of the Republic of South Africa.</li>
                  <li>"Business Day" means any day other than a Saturday, Sunday or public holiday in South Africa.
                  </li>
                  <li>“CPA” means the Consumer Protection Act 68 of 2008, as amended.</li>
                  <li>"ECT Act" means the Electronic Communications and Transactions Act 25 of 2002, as amended.
                  </li>
                  <li>“Subscription” means a subscription for any of the additional services offered by us to Users whether for a fee or otherwise.
                  </li>
                </ol>
              </li>

            </ol>

          </li>

          <li id="section2" class="legal-head">Consumer Protection Act

            <ol>
              <li>In regard to any Users who are consumers for purposes of the CPA the provisions listed in sub-clause 2 below are expressly drawn to your attention because such provisions :
                <ol>
                  <li>may limit the risk or liability of Hellopeter or a third party; and/or</li>
                  <li>may create risk or liability for you; and/or</li>
                  <li>may compel you to indemnify Hellopeter or a third party; and/or</li>
                  <li>serves as an acknowledgement, by you, of a fact.</li>
                </ol>
              </li>
              <li>The relevant provisions for purposes of sub-clause 1 above are:
                <ol>
                  <li>clause 13 (Indemnity) in terms of which you agree to indemnify us from certain third party claims. The effect of the indemnity is that you may be obliged to reimburse us if any third party makes a claim against us in
                    connection with the matters referred to therein;
                  </li>
                  <li>clause 14 (Disclaimers and Limitations of Liability) in terms of which: i) we limit the scope of our liability to you; ii) you agree to reduce the types of remedies you have against us; and iii) you agree to us
                    limiting the quantum and type of damages and other amounts you may claim from us. The effect thereof may be to reduce and/or waive and/or limit certain claims you might otherwise have had against us.
                  </li>
                </ol>
              </li>
              <li>Your attention is drawn to these Terms because they are important and should be carefully noted by you.
              </li>
              <li>If there is any provision in these Terms that you do not understand, it is your responsibility to ask Hellopeter to explain it to you before you accept the Terms or continue using the Site.
              </li>
              <li>Nothing in these Terms is intended to or must be understood to unlawfully restrict, limit or avoid any right or obligation, as the case may be, created for either you or Hellopeter in terms of the CPA.
              </li>
              <li>If you are a juristic person:
                <ol>
                  <li>you may have furnished us with copies of your financial statements and/or made other disclosures of a financial nature (collectively the “financial disclosures”) to us for purposes of us determining whether the CPA
                    applies to the agreement between us constituted by these Terms;
                  </li>
                  <li>you warrant and undertake that the financial disclosures are true, accurate and correct at the time same were furnished;
                  </li>
                  <li>to the extent we rely upon the warranties in the previous sub clause, you indemnify us in respect of loss, damage or expense incurred or suffered by us in connection with a breach thereof.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li id="section3" class="legal-head">ELECTRONIC COMMUNICATIONS AND TRANSACTIONS ACT

            <ol>
              <li><strong>Information and required disclosures under section 43 of the ECT Act that are not contained elsewhere in these Terms:</strong>
                <ol>
                  <li>the full name and legal status of Hellopeter is TKJ Design (Pty) Ltd (Registration Number: 2014/116057/07), a company duly incorporated in accordance with the laws of the Republic of South Africa (“RSA”), whose full
                    and further details appear hereunder:
                    <ol>
                      <li>Directors: Alon Rom, Ronen Jackson, Paul Rutherford;</li>
                      <li>Telephone Number: 021 206 5444;</li>
                      <li>E-mail Address: legal@hellopeter.com;</li>
                      <li>Site: <a href="https://www.hellopeter.com">hellopeter.com</a>;</li>
                      <li>Physical Business Address: 80 Strand Street, Cape Town, South Africa.
                      </li>
                    </ol>
                  </li>
                  <li>Records of transactions: Where you conclude an order for any Subscriptions on this Site, this will be confirmed by a statement displayed online immediately after the order is submitted and can be saved or printed. In
                    addition, your order history may be viewed on the Site under the Accounts header.
                  </li>
                </ol>
              </li>
            </ol>

          </li>

          <li id="section4" class="legal-head">CHANGES TO THE TERMS OF SERVICE
            <ol>
              <li>We may modify the Terms from time to time.</li>
              <li>You understand and agree that your access to or use of the Site is governed by these Terms effective at the time of your access to or use of the Site.
              </li>
              <li>If we make material changes to these Terms, we will notify you either by email or by posting a notice on the Site prior to the effective date of the changes.
              </li>
              <li>We will also indicate at the top of this page the date that revisions were last made.</li>
              <li>You should revisit these Terms on a regular basis as revised versions will be binding on you.
              </li>
              <li>Any such modification will be effective upon our posting of new Terms.</li>
              <li>Terms last reviewed on 31 October 2023</li>
              <li><strong>You understand and agree that your continued access to or use of the Site after the effective date of modifications to these Terms indicates your acceptance of the modifications.</strong></li>
            </ol>
          </li>

          <li id="section5" class="legal-head">USING THE SITE
            <ol>

              <li>Eligibility
                <ol>
                  <li>To access or use the Site:
                    <ol>
                      <li>if you are a natural person, you must be 18 years or older and have the requisite power, authority and capacity to enter into these Terms;
                      </li>
                      <li>if you are a company or other juristic entity, then the person agreeing to these Terms on behalf of that company or juristic entity hereby represents and warrants that he or she is authorized and lawfully able to
                        bind that company or juristic entity to these Terms.
                      </li>
                    </ol>
                  </li>

                  <li>We may in our discretion request that you furnish us with evidence of compliance with the previous sub-clause and you must deliver same to us promptly.
                  </li>

                  <li>The place of conclusion of the agreement between us is our main place of business in Cape Town, South Africa.
                  </li>

                  <li>You may not access or use the Site if we have previously banned you from the Site.</li>

                </ol>

                <li>Permission to Use the Site
                  <br/> We grant you permission to use the Site subject to the restrictions in these Terms. Your use of the Site is at your own risk, including the risk that you might be exposed to Content that is offensive, indecent,
                  inaccurate, objectionable, or otherwise inappropriate.
                </li>

                <li>Site Availability
                  <br/> The Site may be modified, updated, interrupted, suspended or discontinued at any time without notice or liability.

                </li>

                <li>User Accounts
                  <ol>
                    <li>You must create an account and provide certain information about yourself in order to use some of the features that are offered through the Site.
                    </li>
                    <li>You are responsible for maintaining the confidentiality of your account password.</li>
                    <li>You are also responsible for all activities that occur in connection with your account.
                    </li>
                    <li>You agree to notify us immediately of any unauthorized use of your account.</li>
                    <li>Your account is for your personal use only.</li>
                    <li>You must provide complete and accurate information about yourself.</li>
                    <li>You must not:
                      <ol>
                        <li>impersonate someone else (e.g., adopt the identity of a celebrity or your next-door neighbor);
                        </li>
                        <li>create or use an account for anyone other than yourself;</li>
                        <li>provide an email address other than your own; or</li>
                        <li>create multiple accounts.</li>
                      </ol>
                    </li>

                    <li>If you use a pseudonym, take care to note that others may still be able to identify you if, for example, you include identifying information in your postings, use the same account information on other sites, or allow
                      other sites to share information about you with Hellopeter.
                    </li>
                    <li>Please read our <a href="">Privacy Policy</a> for more information.</li>
                  </ol>
                </li>

                <li><strong>Transfer of Personal Information</strong>
                  <ol>
                    <li><strong>We store all data including personal information about you on servers which are situated outside of South Africa. </strong></li>
                    <li><strong>You consent to us transferring your personal information to another country for storage, back up and operational purposes.</strong></li>
                    <li><strong>We will comply with the legal requirements, if any, under Applicable Law relating to the transfer of personal information in this manner.</strong></li>
                    <li><strong>If you are a business and you transfer to us, any personal information of a third party, for any purpose connected to any services provided by us to you, you warrant to us that you have obtained the consent
                      of such third party to such transfer, to the extent it is required by Applicable Law.</strong></li>
                    <li><strong>If you are reviewer and your review is in response to an invitation sent to you by us on behalf of a business, then by posting your review you consent to the transfer of your personal information by such
                      business to Hellopeter for such purpose, to the extent it is required by Applicable Law.</strong></li>
                  </ol>
                </li>

                <li>Communications from Hellopeter and other Users
                  <ol>
                    <li>By creating an account, you agree to receive certain communications in connection with the Site.
                    </li>
                    <li>For example, you might receive notifications from us in connection with Your Content.</li>
                    <li>You may receive e-mail newsletters from us.</li>
                    <li>You may also receive transactional e-mail communication from us.</li>
                  </ol>
                </li>
            </ol>
          </li>

          <li id="section6" class="legal-head">CONTENT

            <ol>
              <li>Responsibility for Your Content
                <ol>
                  <li>You alone are responsible for Your Content and any consequences that flow therefrom.</li>
                  <li>Any business may respond to a reviewer in accordance with the following procedure:
                    <ol>
                      <li>Any business reviewed on the Site, irrespective of whether the business has purchased a Subscription service or not, may object to a review posted on the Site in accordance with the following procedure:
                        <ol class="margin-top-10">
                          <li>by clicking the report review flag on the Site, and thereafter by completing the fields required and submitting the request;
                          </li>
                          <li>upon receipt of the response from the business, the Content of the review will be investigated and will be removed if we are of the view the review is not compliant with our Content Guidelines ;
                          </li>
                          <li>if we are of the view the review is compliant with our Content Guidelines, we will contact the reviewer and request the reviewer to confirm that the review posted by the reviewer is unbiased, factual, and
                            correct
                            and that the reviewer stands by the review. We may (but are not obliged in any way) to ask for additional materials or information to verify the facts stated in the review. This could include for example,
                            receipts
                            and invoices, order confirmations, emails and screenshots of your interactions with customer service of the business;
                          </li>
                          <li>if the reviewer confirms that the review is unbiased, factual and correct and that the reviewer wishes to stand by the review, the review shall remain on the Site (without prejudice to remove any review in our
                            sole discretion);
                          </li>
                          <li>if the User confirms that the review is unbiased, factual and correct and that the User wishes to stand by the review, the review shall remain on the Site;
                          </li>
                          <li>should the reviewer not respond to the request from us within 48 (forty-eight) hours, the review will be deleted from the Site.
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li>Only businesses that have purchased a Subscription service may respond to a review posted on the Site, and in accordance with the following procedure:
                    <ol class="margin-top-10">
                      <li>by clicking the "Reply" icon corresponding a particular review on the Site, and thereafter by completing the fields required and submitting the reply;</li>
                    </ol>
                  </li>
                  <li>To the extent that the Subscription service purchased by a business offers a free trial period, if at the end of the trial period the business elects not to continue with the Subscription service, any reply posted by
                    the business during the period will remain on the Site but no further right to reply will be permitted.
                  </li>
                  <li>
                    Reviewers may remove a review posted by them at any time.
                  </li>
                  <li id="content_guidelines">These are some of the Content Guidelines we require that you follow:
                    <ol>
                      <li>As a reviewer you should: i) use simple, polite, respectful and factual language to share your experience; ii) not make non-specific or generalised allegations about a business or the people working there (e.g.
                        “everyone who works there is dishonest”) and rather focus on explaining the particular experience you had – what was supposed to happen, what went wrong, how it could it have been better; iii) not make personal
                        attacks on representatives of the business (e.g. “Peter is dishonest”).
                      </li>
                      <li>Language should not constitute a threat, harassment, hate speech, or be lewd, or display bigotry.
                      </li>
                      <li>Users are prohibited from posting unlawful content, including defamatory, insulting, private, racist, sexist, threatening, harassing, degrading, fraudulent, obscene, indecent, misleading, abusive or otherwise
                        objectionable material (“unlawful content”) on Hellopeter.
                      </li>
                      <li>Users are prohibited from posting content that is patently offensive to the online community, such as content that promotes racism, bigotry, hatred or physical harm of any kind against any group or individual.
                      </li>
                      <li>Users are prohibited from posting content that would constitute, encourage, promote or provide instructions for the conduct of an illegal activity, criminal offence, give rise to civil liability, violate the rights
                        of any party in any country of the world, or that would otherwise create liability or violate any local, national or international law.
                      </li>
                      <li>Users are prohibited from posting content that provides instructional information about illegal activities such as making or buying illegal weapons, violating someone’s privacy or providing or creating computer
                        viruses.
                      </li>
                      <li>Users are prohibited from posting personal information such as their name, email address, contact details, address and any other identifying information.
                      </li>
                      <li>Users are prohibited from impersonating any person or entity or otherwise misrepresenting your affiliation with a person or entity, including Hellopeter.
                      </li>
                      <li>Users are prohibited from posting advertising and other content containing commercial activities in their reviews, including unsolicited promotions, mass mailing or “spamming”, transmission of “junk mail”, “chain
                        letters”, political campaigning, contests, raffles, solicitations, sweepstakes, barter and pyramid schemes.
                      </li>
                      <li>By posting a review, you the reviewer confirm you are a bona fide customer of the business that you are writing a review about, and that all facts contained in your review are true and accurately describe your
                        experience. You agree that if you have been furnished with an incentive in exchange for writing a review this offer did not influence the content of your review. Hellopeter regards any breach of this undertaking as a
                        material breach of these Terms.
                      </li>
                      <li>Your contributions should be unbiased and objective. For example, you shouldn’t write reviews of your own business or employer, your friends’ or relatives’ business, your peers or competitors in your industry, or
                        businesses in your networking group.
                      </li>
                      <li>Please make sure your contributions are relevant and appropriate to the forum. For example, Hellopeter is not a platform for employees to write reviews about their employers.
                      </li>
                      <li>Don’t post other people’s private information without their permission, including, but not limited to, their surname, address, phone numbers, email address and credit card number.
                      </li>
                      <li>Don’t use the intellectual property of a third party without their permission. In this regard Users are prohibited from posting content that may infringe any patent, trademark, trade secret, copyright or other
                        intellectual or proprietary right of any party. In particular, Users may not post content that promotes an illegal or unauthorised copy of another person’s copyrighted work, such as providing pirated computer
                        programmes or links to them, providing information to circumvent manufacture-installed copy-protect devices, or providing pirated music or links to pirated music files.
                      </li>
                      <li>Users are prohibited from posting content that contains restricted or password only access pages, or hidden pages or images (those not linked to or from another accessible page).
                      </li>
                      <li>Users are prohibited from posting viruses, corrupted data or other harmful or destructive files.</li>
                      <li>Users are prohibited from posting content or links to content that, in the sole judgment of Hellopeter:
                        <ol>
                          <li>violate the Content Guidelines set out above;</li>
                          <li>is objectionable;</li>
                          <li>restricts or inhibits any other person from using or enjoying the Site; or</li>
                          <li>may expose Hellopeter or its affliates or its Users to any harm or liability of any type;
                          </li>
                        </ol>
                      </li>
                      <li>as a business you undertake that you will not attempt to mislead, influence or impersonate a competing business or consumer including by:
                        <ol>
                          <li>writing a review of your own business;</li>
                          <li>getting your employees to write a review of your business;</li>
                          <li>writing a review of any business that your owners are employed at, own, manage, or have a financial interest in;</li>
                          <li>utilising any optimisation company, marketing organisation, or third party to submit reviews;</li>
                          <li>impersonating a competitor;</li>
                          <li>asking friends or relatives to write positive reviews.</li>
                          <li>submitting reviews on behalf of consumers;</li>
                          <li>pressuring consumers to remove a negative review on Hellopeter.</li>
                          <li>asking consumers to remove their reviews in return for a discount or incentive.</li>
                          <li>prohibiting or discouraging consumers from posting negative or critical reviews of their experience.</li>
                          <li>reviewing a direct competitor, even if you are a bona fide customer of the competitor.</li>
                          <li>running or consideration of any incentive program that involves asking consumers to write a review of any nature in return for a discount, incentive or prize requires prior written approval from Hellopeter.
                          </li>
                        </ol>
                      </li>
                      <li>if you as a business breach the aforegoing paragraph:
                        <ol>
                          <li>we reserve the right to publicize your conduct on the Site in such manner as we deem appropriate. This may take the form of a penalty notice, explaining that your business’ reviews are suspicious. We post these
                            warnings rather than removing your business from the site entirely because the notice gives consumers the information they need to make the most informed decisions;
                          </li>
                          <li>we may apply penalties to how your business is scored and ranked on the Site, the effect of which will be that : i) your ranking will drop; ii) your business to appear later in a list of similar businesses;
                          </li>
                          <li>we may decide that your business is no longer eligible for recognition in the form of Hellopeter top lists, news and press releases.</li>
                          <li>we may block or remove the fraudulent reviews.</li>
                        </ol>
                      </li>
                      <li>
                        You assume all risks associated with Your Content, including anyone's reliance on its quality, accuracy, or reliability, or any disclosure by you of information in Your Content that makes you personally identifiable.
                      </li>
                      <li>
                        You represent and warrant that you own, or have the necessary permissions to use and authorize the use of, Your Content as described herein. This includes but is not limited to any personal information of any person
                        referred to in a review.
                      </li>
                      <li>You may not imply that Your Content is in any way sponsored or endorsed by Hellopeter.</li>
                      <li>
                        You may expose yourself to liability if, for example, Your Content contains material that is false, intentionally misleading, or defamatory; violates any third-party right, including any copyright, trademark, patent,
                        trade secret, moral right, privacy right, right of publicity, or any other intellectual property or proprietary right; contains material that is unlawful, including illegal hate speech or pornography; exploits or
                        otherwise harms minors; or violates or advocates the violation of any law or regulation.
                      </li>
                      <li>
                        If you are a Registered User, and you ask a reviewer to post a positive review about you on the Site, including in your capacity as an employee of, or service provider to a business, as between you and Hellopeter,
                        you will be deemed to have consented to the Hellopeter processing your personal information in such review, but without prejudice to any rights you may have under Applicable Law to have same removed subsequently.
                      </li>
                      <li>Our Right to Use Your Content
                        <ol>
                          <li>
                            We may use Your Content in a number of different ways, including publicly displaying it, reformatting it, incorporating it into advertisements and other works, creating derivative works from it, promoting it,
                            distributing it, and allowing others to do the same in connection with their own websites and media platforms ("<strong>Other Media</strong>").
                          </li>
                          <li>
                            As such, you hereby irrevocably grant us world-wide, perpetual, non-exclusive, royalty-free, assignable, sublicensable, transferable rights to use Your Content for any purpose.
                          </li>
                          <li>
                            Please note that you also irrevocably grant the Users of the Site and any Other Media the right to access Your Content in connection with their use of the Site and any Other Media.
                          </li>
                          <li>
                            Finally, you irrevocably waive, and cause to be waived, against Hellopeter and its Users any claims and assertions of moral rights or attribution with respect to Your Content.
                          </li>
                          <li>
                            By "use" we mean use, copy, publicly perform and display, reproduce, distribute, modify, translate, remove, analyze, commercialize, and prepare derivative works of Your Content.
                          </li>
                        </ol>
                      </li>
                      <li>Ownership
                        <ol>
                          <li>As between you and Hellopeter, you own Your Content.</li>
                          <li>We own the Hellopeter Content, including but not limited to visual interfaces, interactive features, graphics, design, compilation, including, but not limited to, our compilation of User Content and other Site
                            Content, computer code, products, software, aggregate User review ratings, and all other elements and components of the Site excluding Your Content, User Content and Third Party Content.
                          </li>
                          <li>
                            We also own the copyrights, trademarks, service marks, trade names, and other intellectual and proprietary rights throughout the world ("<strong>IP Rights</strong>") associated with the Hellopeter Content and the
                            Site, which are protected by copyright, patent, trademark laws and all other applicable intellectual and proprietary rights and laws.
                          </li>
                          <li>
                            As such, you may not modify, reproduce, distribute, create derivative works or adaptations of, publicly display or in any way exploit any of the Hellopeter Content in whole or in part except as expressly
                            authorized by us. Except as expressly and unambiguously provided herein, we do not grant you any express or implied rights, and all rights in and to the Site and the Hellopeter Content are retained by us.
                          </li>
                        </ol>
                      </li>
                      <li>Advertising
                        <ol>
                          <li>
                            Hellopeter and its licensees may publicly display advertisements and other information adjacent to or included with Your Content. You are not entitled to any compensation for such advertisements. The manner, mode
                            and extent of such advertising are subject to change without specific notice to you.
                          </li>
                        </ol>
                      </li>
                      <li>Other
                        <ol>
                          <li>
                            User Content (including any that may have been created by Users employed or contracted by Hellopeter) does not necessarily reflect the opinion of Hellopeter.
                          </li>
                          <li>
                            We reserve the right in our sole discretion to remove, screen, edit, or reinstate User Content from time to time at our sole discretion for any reason or no reason, and without notice to you. For example, we may
                            remove a review if we believe it violates our
                            <a href="">Content Guidelines</a>.
                          </li>
                          <li>
                            We have no obligation to retain or provide you with copies of Your Content, nor do we guarantee any confidentiality with respect to Your Content.
                          </li>
                          <li>
                            You should independently verify any User Content on the Site before relying on it. The information and material on the Site is not a substitute for your own judgment. You should make all necessary enquiries and
                            take all necessary professional advice before making use of goods or services referred to on the Site.
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li id="section7" class="legal-head">RESTRICTIONS
            <ol>
              <li>We are under no obligation to enforce these Terms on your behalf against another User. While we encourage you to let us know if you believe another User has violated these Terms, we reserve the right to investigate and
                take appropriate action at our sole discretion.
              </li>
              <li>You agree not to, and will not assist, encourage, or enable others to use the Site to:
                <ol>
                  <li>Violate our <a href="">Content Guidelines</a>;</li>
                  <li>Violate any third party's rights, including any breach of confidence, copyright, trademark, patent, trade secret, moral right, privacy right, right of publicity, or any other intellectual property or proprietary right;
                  </li>
                  <li>Threaten, stalk, harm, or harass others, or promote bigotry or discrimination;</li>
                  <li>Promote a business or other commercial venture or event, or otherwise use the Site for commercial purposes, save as may be permitted in terms of a Subscription service or as otherwise expressly permitted by Hellopeter;
                  </li>
                  <li>Save as otherwise agreed with us, send bulk emails, surveys, or other mass messaging, whether commercial in nature or not; engage in keyword spamming, or otherwise attempt to manipulate the Site's search results or any
                    third party website;
                  </li>
                  <li>Solicit personal information from minors, or submit or transmit pornography; or</li>
                  <li>violate any Applicable Law.</li>
                </ol>
              </li>

              <li>You also agree not to, and will not assist, encourage, or enable others to:
                <ol>
                  <li>breach these Terms;</li>
                  <li>Modify, adapt, appropriate, reproduce, distribute, translate, create derivative works or adaptations of, publicly display, sell, trade, or in any way exploit the Site or Site Content (other than Your Content), except
                    as expressly authorized by Hellopeter;
                  </li>
                  <li>Use any robot, spider, site search/retrieval application, or other automated device, process or means to access, retrieve, scrape, or index any portion of the Site or any Site Content;
                  </li>
                  <li>Reverse engineer any portion of the Site;</li>
                  <li>Remove or modify any copyright, trademark or other proprietary rights notice that appears on any portion of the Site or on any materials printed or copied from the Site;
                  </li>
                  <li>Record, process, or mine information about other Users;</li>
                  <li>Access, retrieve or index any portion of the Site for purposes of constructing or populating a searchable database of business reviews;
                  </li>
                  <li>Reformat or frame any portion of the Site;</li>
                  <li>Take any action that imposes, or may impose, in our sole discretion, an unreasonable or disproportionately large load on Hellopeter's technology infrastructure or otherwise make excessive traffic demands of the Site;
                  </li>
                  <li>Attempt to gain unauthorized access to the Site, User accounts, computer systems or networks connected to the Site through hacking, password mining or any other means;
                  </li>
                  <li>Use the Site or any Site Content to transmit any computer viruses, worms, defects, Trojan horses or other items of a destructive nature (collectively, <strong>"Viruses"</strong>);
                  </li>
                  <li>Use any device, software or routine that interferes with the proper working of the Site, or otherwise attempt to interfere with the proper working of the Site;
                  </li>
                  <li>Use the Site to violate the security of any computer network, crack passwords or security encryption codes; disrupt or interfere with the security of, or otherwise cause harm to, the Site or Site Content; or
                  </li>
                  <li>Remove, circumvent, disable, damage or otherwise interfere with any security-related features of the Site, features that prevent or restrict the use or copying of Site Content, or features that enforce limitations on
                    the use of the Site.
                  </li>
                </ol>
              </li>

              <li>The restrictions in sub-clause 2 and sub-clause 3 above only apply to the extent permissible under Applicable Law. Nevertheless, you agree not to act contrary to them (even if permissible under Applicable Law) without
                providing 30 days' prior written notice to us, together with any information that we may reasonably require to give us an opportunity to provide alternative remedies or otherwise accommodate you at our sole discretion.
              </li>
            </ol>
          </li>

          <li id="section8" class="legal-head">GUIDELINES AND POLICIES

            <ol>
              <li>Content Guidelines
                <br/> You represent that you have read and understood our <a href="">Content Guidelines</a>.
              </li>

              <li>Privacy
                <ol>
                  <li>You represent that you have read and understood our <a href="">Privacy Policy</a>.
                  </li>
                  <li>As a business you undertake that :
                    <ol>
                      <li>You shall not request any personal details of any Users who have posted a review about your business directly from the User;
                      </li>
                      <li>You shall only obtain such personal details from Hellopeter in accordance with the procedures and processes adopted by the Site.
                      </li>
                    </ol>
                  </li>
                </ol>

                <li>Copyright And Trademark Disputes
                  <ol>
                    <li>If you believe any of your intellectual property rights are being infringed on the Site please send us a written notice containing the following information:
                      <ol>
                        <li>please identify the infringing content on the Site and furnish us with a screen shot thereof;
                        </li>
                        <li>please confirm in your written notice that you are the owner of the relevant intellectual property, or an agent for the owner, and that you believe such content is breaching your, or the owner's, as the case may
                          be, intellectual property rights;
                        </li>
                        <li>please provide your relevant contact information including a physical address, telephone number and email address.
                        </li>
                      </ol>
                    </li>
                    <li>We will respond to your query within a reasonable time, and deal with the query in accordance with Applicable Law.
                    </li>
                    <li>You can send us your infringement notices by any of the following methods:
                      <ol>
                        <li>to our physical address being 80 Strand Street, Cape Town, South Africa;
                        </li>
                        <li>by email to legal@hellopeter.com<strong>.</strong></li>
                      </ol>
                    </li>

                  </ol>
                </li>
            </ol>
          </li>

          <li id="section9" class="legal-head">SUBSCRIPTIONS
            <ol>
              <li><strong>Order Process</strong>
                <ol>
                  <li>You should regard nothing contained on this Site as an offer by Hellopeter to sell any products or services to you, but rather as an invitation for you to do business with Hellopeter
                    <strong>. </strong></li>
                  <li>Any order for a Subscription that you place through the Site constitutes an offer by yourself to purchase a Subscription from Hellopeter in the manner contemplated further herein (“the Offer”).
                  </li>
                  <li>You may submit Offers via the Site at any time in the manner contemplated below.</li>
                  <li>When making an Offer, you will be required to complete the entire checkout process with respect thereto (“the Checkout Process”), which Checkout Process shall include but not be limited to you:
                    <ol>
                      <li>selecting the relevant Subscription service; and</li>
                      <li>providing Hellopeter with your credit card payment details; and</li>
                      <li>reviewing the details of the entire Offer and confirming that same are correct.</li>
                    </ol>
                  </li>
                  <li>A binding agreement between yourself and Hellopeter in respect of any Offer will only be entered into at the stage at which Hellopeter receives the Offer and confirms its acceptance thereof to you (“the Order”).
                    Hellopeter reserves the right to refuse to accept any Offer.
                  </li>
                </ol>
              </li>
              <li><strong>Pricing of </strong><strong>Subscriptions</strong>
                <ol>
                  <li>All prices of Subscriptions are in South African Rand values and are inclusive of value added tax (“VAT”), unless otherwise stated.
                  </li>
                  <li>The price payable by yourself for the Order will be the VAT inclusive amount reflected on the Site during the Checkout Process in respect of the purchase price of the Subscription.
                  </li>
                </ol>
              </li>
              <li><strong>Payment</strong><strong> of the purchase price in respect of a Subscription</strong>
                <ol>
                  <li>We are committed to providing secure online payment facilities.</li>
                  <li>Payments are made through secure banking/payment gateways, which are not owned by Hellopeter or under Hellopeter’s control, and for which you acknowledge Hellopeter is not responsible in law.
                  </li>
                  <li>It is your responsibility to make sure that you read the terms and conditions of such service providers prior to making payment.
                  </li>
                  <li>Hellopeter supports the following payment instruments:
                    <ol>
                      <li>Electronic Funds Transfer into the bank account stipulated for this purpose on the invoice furnished to you;
                      </li>
                      <li>credit card.</li>
                    </ol>
                  </li>
                  <li>Where payment is made by credit card; we may require certain additional information from you in order to authorise and/or verify the validity of payment. We reserve the right to withhold commencing any Subscription
                    services until such time as the additional information is received by us and authorisation is obtained for the amounts. Should we do not receive such authorisation, your Order for the Subscription will be cancelled.
                  </li>
                  <li>You warrant that you are fully authorised to use the credit card supplied for purposes of paying the Subscription.
                  </li>
                  <li>You may contact us via email at <a href="mailto:billing@hellopeter.com">billing@hellopeter.com</a> to obtain a full record of your transaction. We will confirm your Order with you via email once your Order is placed
                    with us and you have provided us with your email address.
                  </li>
                </ol>
              </li>
              <li><strong>Access to the Subscription</strong>
                <ol>
                  <li>Subject to sub-clause 2 below, no Subscription services shall commence in respect of any Order until payment in full in respect of such Order has been received and verified by Hellopeter.
                  </li>
                  <li>If the applicable terms of the Subscription service provided for recurring payments on a monthly basis, then:
                    <ol>
                      <li>no Subscription service shall commence in respect of any Order until payment in full of the first installment payable in respect of such Order has been received and verified by Hellopeter;
                      </li>
                      <li>your continued access to the Subscription service shall be conditional on you continuing to make payment of the subsequent installments, as and when they fall due for payment.
                      </li>
                    </ol>
                  </li>
                  <li>A Subscription service purchased in terms of an Order will, for all purposes herein, be deemed to commence on the date and at the time the payment in full is received by Hellopeter.
                  </li>
                  <li>All amounts shall be paid by you without deduction or set-off whatsoever.</li>
                  <li>You undertake to pay all amounts payable in connection with a Subscription service ordered by you, on due date.
                  </li>
                </ol>
              </li>
              <li><strong>Cancellation of Subscription</strong>
                <ol>
                  <li>Once an Offer has been accepted by us, same will not be capable of being cancelled and you will be held liable for the full value of the Order; provided that:
                    <ol>
                      <li>you will be entitled to, in terms of section 44 of the ECT Act, cancel such Order within 7 (Seven) days after the date of access to the Subscription services commencing; and
                      </li>
                      <li>nothing contained in the preceding sub-clause shall be construed as preventing you from terminating your Subscription service in accordance with:
                        <ol>
                          <li>any other provisions of these Terms; or</li>
                          <li>applicable law, including if the CPA applies to the transaction constituted by the Offer, in accordance with the provisions of the CPA, subject to our rights, if any, under the CPA in such circumstances.
                          </li>
                        </ol>
                      </li>

                    </ol>

                    <li>If you exercise your cancellation rights in terms of section 44 of the ECT Act:
                      <ol>
                        <li>the only charge that may be levied on you by Hellopeter is the direct cost of cancelling the Subscription (which direct cost shall, for the avoidance of any doubt, comprise the costs to Hellopeter of the
                          cancellation of the Subscription); and
                        </li>
                        <li>if payment for the Subscription has been effected by you prior to your exercising the right referred to above, then you are entitled to a full refund of such payment, which refund must be made within 30 (Thirty)
                          days of the date of cancellation.
                        </li>
                      </ol>
                    </li>

                </ol>
              </li>

              <li>Subscription Features
                <ol>
                  <li>The additional services available to you will depend on the Subscription service purchased by you as outlined at the time of purchase and as such Subscription service is amended from time to time.
                  </li>
                  <li>If your Subscription provides for an annual fee payable in advance, then :
                    <ol>
                      <li>your Subscription will endure for an indefinite period until terminated under the next sub-clause;
                      </li>
                      <li>you may give a notice of termination at any time but such notice shall only be effective at the end of the then current annual period in which notice is given by you;</li>
                      <li>your annual Subscription fee will be due and payable on each anniversary of the date on which your Subscription commenced;
                      </li>
                      <li>your annual Subscription fee, once paid, shall not be refundable for any reason.
                      </li>
                    </ol>
                  </li>
                  <li>If your Subscription provides for only a monthly fee payable in advance, then :
                    <ol>
                      <li>your Subscription will endure for an indefinite period until terminated under the next sub-clause; and
                      </li>
                      <li>you may give notice of termination at any time but such notice shall only be effective at the end of the billing cycle following the billing cycle in which notice is given by you.</li>
                    </ol>
                  </li>
                  <li>We may add or delete features to your Subscription service at any time. Your only remedy if you are unhappy with the changes made to your Subscription service is to cancel your Subscription.
                  </li>
                  <li>We may discontinue any Subscription service at any time on 30 days notice. Your only remedy in such circumstances will be to receive a refund of any amounts paid by you in advance for any period after the Subscription
                    service was discontinued. Such refund shall be determined on a pro rata basis determined with reference to the number of days in the month or in the year, as the case may be, that you paid for but did not receive the
                    Subscription service following discontinuation thereof.
                  </li>
                  <li>Changes in pricing applicable to Subscription services will be given:
                    <ol>
                      <li>in the case of Subscriptions with annual fees, 60 days before the relevant renewal date; and
                      </li>
                      <li>in the case of Subscriptions with monthly fees, on 30 days’ notice to you at any time.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Upon termination of a Subscription for any reason, any unused services or credits forming part of or purchased pursuant to such Subscription, are forfeited without compensation being payable to you.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li id="section11" class="legal-head">CONFLICT WITH OTHER TERMS

            <ol>
              <li>If you purchase any Subscription services, then any specific terms and conditions incorporated into your order or invoice at the time of purchase will also apply (“Subscription Specific Terms”). In the event of any
                conflict between the Subscription Specific Terms and these Terms, the Subscription Specific Terms will prevail.
              </li>
            </ol>

          </li>

          <li id="section12" class="legal-head">SUGGESTIONS AND IMPROVEMENTS
            <br/><span>By sending us any ideas, suggestions, documents or proposals (<strong>"Feedback"</strong>), you agree that (i) your Feedback does not contain the confidential or proprietary information of third parties, (ii) we are under no obligation of confidentiality, express or implied, with respect to the Feedback, (iii) we may have something similar to the Feedback already under consideration or in development, and (iv) you grant us an irrevocable, non-exclusive, royalty-free, perpetual, worldwide license to use, modify, prepare derivative works, publish, distribute and sublicense the Feedback, and you irrevocably waive, and cause to be waived, against Hellopeter and its Users any claims and assertions of any moral rights contained in such Feedback.</span>
          </li>

          <li id="section13" class="legal-head">THIRD PARTIES
            <br/><span>The Site may include links to other websites or applications (each, a "Third Party Site"). We do not control or endorse any Third Party Site. You agree that we are not responsible for the availability or contents of such Third Party Sites. Your use of Third Party Sites is at your own risk.</span>
          </li>

          <li id="section14" class="legal-head">INDEMNITY
            <br/><span>You agree to indemnify, defend, and hold Hellopeter, its shareholders, subsidiaries, affiliates, any related companies, suppliers, licensors and partners, and the officers, directors, employees, agents and representatives of each of them (collectively, the "Hellopeter Entities") harmless, including costs, liabilities and legal fees, on an attorney and own client scale, from any claim or demand made by any third party arising out of or relating to (i) your access to or use of the Site, (ii) your violation of these Terms, (iii) any products or services purchased or obtained by you in connection with the Site, or (iv) the infringement by you, or any third party using your account, of any intellectual property or other right of any person or entity. Hellopeter reserves the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us and you agree to cooperate with our defense of these claims. You agree not to settle any such matter without the prior written consent of Hellopeter. Hellopeter will use reasonable efforts to notify you of any such claim, action or proceeding upon becoming aware of it. The provisions of this clause shall constitute a stipulation for the benefit of each of the Hellopeter Entities, capable of acceptance by them at any time.</span>
          </li>

          <li id="section15" class="legal-head">DISCLAIMERS AND LIMITATIONS OF LIABILITY
            <ol>
              <li>PLEASE READ THIS SECTION CAREFULLY SINCE IT LIMITS THE LIABILITY OF THE HELLOPETER ENTITIES TO YOU. EACH OF THE SUBCLAUSES BELOW ONLY APPLIES UP TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW. NOTHING HEREIN IS
                INTENDED TO LIMIT ANY RIGHTS YOU MAY HAVE WHICH MAY NOT BE LAWFULLY LIMITED. IF YOU ARE UNSURE ABOUT THIS OR ANY OTHER SECTION OF THESE TERMS, PLEASE CONSULT WITH A LEGAL PROFESSIONAL PRIOR TO ACCESSING OR USING THE SITE. BY
                ACCESSING OR USING THE SITE, YOU REPRESENT THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO THESE TERMS, INCLUDING THIS SECTION. YOU ARE GIVING UP SUBSTANTIAL LEGAL RIGHTS BY AGREEING TO THESE TERMS.
              </li>
              <li>THE SITE IS MADE AVAILABLE TO YOU ON AN "AS IS", "WITH ALL FAULTS" AND "AS AVAILABLE" BASIS, WITH THE EXPRESS UNDERSTANDING THAT THE HELLOPETER ENTITIES MAY NOT MONITOR, CONTROL, OR VET USER CONTENT. AS SUCH, YOUR USE OF
                THE SITE IS AT YOUR OWN DISCRETION AND RISK. THE HELLOPETER ENTITIES MAKE NO CLAIMS OR PROMISES ABOUT THE QUALITY, ACCURACY, OR RELIABILITY OF THE SITE, ITS SAFETY OR SECURITY, OR THE SITE CONTENT. ACCORDINGLY, THE
                HELLOPETER ENTITIES ARE NOT LIABLE TO YOU FOR ANY LOSS OR DAMAGE THAT MIGHT ARISE, FOR EXAMPLE, FROM THE SITE'S INOPERABILITY, UNAVAILABILITY OR SECURITY VULNERABILITIES OR FROM YOUR RELIANCE ON THE QUALITY, ACCURACY, OR
                RELIABILITY OF ANY BUSINESS REFERRED TO ON THE SITE, RATINGS, REVIEWS (INCLUDING THEIR CONTENT, ORDER, AND DISPLAY), OR METRICS FOUND ON, USED ON, OR MADE AVAILABLE THROUGH THE SITE.
              </li>
              <li>SPECIAL NOTICE TO BUSINESSES WHO CHOOSE TO REPORT A REVIEW: BY SUBMITTING SAME YOU UNDERTAKE NOT TO INSTITUTE LEGAL ACTION OR TAKE ANY STEPS WHATSOEVER AGAINST THE HELLOPETER ENTITIES, AS A RESULT OF ANY CONTENT POSTED ON
                THE SITE BY A REVIEWER. YOU FURTHER ACKNOWLEDGE THAT THE PERSONAL DETAILS OF ANY REVIEWER (NAME, CONTACT NUMBER, EMAIL ADDRESS AND ANY OTHER IDENTIFYING INFORMATION) MAY BE DISCLOSED TO YOU FOR THE SOLE PURPOSE OF ALLOWING
                THE BUSINESS TO RESOLVE THE COMPLAINT CONCERNING YOUR BUSINESS POSTED BY THE USER. THE BUSINESS UNDERTAKES NOT TO INSTITUTE LEGAL ACTION OR TAKE ANY STEPS WHATSOEVER AGAINST ANY REVIEWER, AS A RESULT OF ANY CONTENT POSTED ON
                THE SITE BY THE REVIEWER.
              </li>
              <li>THE HELLOPETER ENTITIES MAKE NO CLAIMS OR PROMISES WITH RESPECT TO ANY THIRD PARTY, SUCH AS THE BUSINESSES OR ADVERTISERS LISTED ON THE SITE OR THE SITE'S USERS. ACCORDINGLY, THE HELLOPETER ENTITIES ARE NOT LIABLE TO YOU
                FOR ANY LOSS OR DAMAGE THAT MIGHT ARISE FROM THEIR ACTIONS OR OMISSIONS, INCLUDING, FOR EXAMPLE, IF ANOTHER USER OR BUSINESS MISUSES YOUR CONTENT, IDENTITY OR PERSONAL INFORMATION, OR IF YOU HAVE A NEGATIVE EXPERIENCE WITH
                ONE OF THE BUSINESSES OR ADVERTISERS LISTED OR FEATURED ON THE SITE. YOUR PURCHASE AND USE OF PRODUCTS OR SERVICES OFFERED BY THIRD PARTIES THROUGH THE SITE IS AT YOUR OWN DISCRETION AND RISK.
              </li>
              <li>THE HELLOPETER ENTITIES EXPRESSLY DISCLAIM ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES AS TO THE PRODUCTS OR SERVICES OFFERED BY BUSINESSES LISTED ON THE SITE, AND IMPLIED WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. NO ORAL OR WRITTEN INFORMATION OR ADVICE PROVIDED TO YOU BY A REPRESENTATIVE OF ONE OF THE HELLOPETER ENTITIES SHALL CREATE A REPRESENTATION OR
                WARRANTY.
              </li>
              <li>YOUR SOLE AND EXCLUSIVE RIGHT AND REMEDY IN CASE OF DISSATISFACTION WITH THE SITE, RELATED SERVICES, OR ANY OTHER GRIEVANCE SHALL BE YOUR TERMINATION AND DISCONTINUATION OF ACCESS TO, OR USE OF THE SITE.
              </li>
              <li>THE HELLOPETER ENTITIES' MAXIMUM AGGREGATE LIABILITY TO YOU FOR LOSSES OR DAMAGES THAT YOU SUFFER IN CONNECTION WITH THE SITE OR THESE TERMS IS LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO THE HELLOPETER ENTITIES IN
                CONNECTION WITH THE SITE IN THE 12 MONTHS PRIOR TO THE ACTION GIVING RISE TO LIABILITY.
              </li>
              <li>THE HELLOPETER ENTITIES DISCLAIM LIABILITY FOR ANY (i) INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, RELIANCE, OR CONSEQUENTIAL DAMAGES, (ii) LOSS OF PROFITS, (iii) BUSINESS INTERRUPTION, (iv) REPUTATIONAL HARM, OR
                (v) LOSS OF INFORMATION OR DATA.
              </li>
              <li>THE PROVISIONS OF THIS CLAUSE SHALL CONSTITUTE A STIPULATION FOR THE BENEFIT OF EACH OF THE HELLOPETER ENTITIES, CAPABLE OF ACCEPTANCE BY THEM AT ANY TIME.
              </li>
            </ol>
          </li>

          <li id="section16" class="legal-head">CHOICE OF LAW AND VENUE
            <br/><span>The laws of the Republic of South Africa (“Applicable Law”) will govern these Terms, as well as any claim, cause of action or dispute that might arise between you and Hellopeter (a "Claim"), without regard to conflict of law provisions. The courts of the Republic of South Africa shall have exclusive jurisdiction in relation to any Claim.</span>
          </li>

          <li id="section17" class="legal-head">TERMINATION
            <ol>
              <li>Subject to the next sub-clause, if you are a Registered User, you may terminate the agreement constituted by these Terms at any time by closing your account, discontinuing your use of the Site, and providing Hellopeter
                with a notice of termination <u> </u>.
              </li>
              <li>If you have subscribed for a Subscription service, you may not terminate the agreement constituted by these Terms, until such Subscription service has terminated or expired in accordance with terms and conditions
                applicable to it or has terminated in accordance with any other method of termination or cancellation referred to in these Terms or permitted in law.
              </li>
              <li>Please review our <a href="/legal/privacy">Privacy Policy</a> for information about what we do with your account when terminated.
              </li>
              <li>Subject to Applicable Law, we may close your account, suspend your ability to use certain portions of the Site, and/or ban you altogether from the Site for any or no reason, and without notice or liability of any kind. Any
                such action could prevent you from accessing your account, the Site, Your Content, Site Content, or any other related information.
              </li>
              <li>In the event of any termination of these Terms, whether by you or us, clauses 6 (Content), 7 (Restrictions), 12 (Third parties), 13 (Indemnity) and 14
                <a href="#">(Disclaimers and Limitations of Liability)</a> will continue in full force and effect, including our right to use Your Content as detailed in clause 6 (Content).
              </li>
            </ol>
          </li>

          <li id="section18" class="legal-head">NOTICES
            <ol>
              <li>We choose for the purposes of the giving of any notice, the serving of any process and for any other purposes arising from these Terms at the physical address, fax numbers and email addresses set forth on the Site (<em>domicilium
                citandi et executandi</em> ("<em>domicilium</em>")).
              </li>
              <li>You choose as your <em>domicilium </em>the physical address and email addresses supplied by you when you registered as a User.
              </li>
              <li>Notices may be sent by prepaid registered post, delivered by hand or communicated by facsimile or email. Unless the contrary is proved, any notice:
                <ol>
                  <li>sent by prepaid registered post will be deemed to have been received on the 5th (Fifth) Business Day after posting;
                  </li>
                  <li>any notice delivered by hand on a Business Day will be deemed to have been received on the date of delivery;
                  </li>
                  <li>any notice transmitted by email on a Business Day will be deemed to have been received on the same day of transmission.
                  </li>
                </ol>
              </li>
              <li>Either of us may by written notice to the other vary our <em>domicilium </em>to any other address in the Republic of South Africa which is not a post office box or <em>poste
                restante</em> (mail holding service), provided that the change will become effective only 14 (fourteen) days after service of the notice in question.
              </li>
              <li>Notwithstanding the above, any notice given in writing in English, and actually received by the party to whom the notice is addressed, will be deemed to have been properly given and received, notwithstanding that such
                notice has not been given in accordance with this clause.
              </li>
            </ol>
          </li>

          <li id="section19" class="legal-head">GENERAL TERMS
            <ol>
              <li>Except as otherwise explicitly set out in these Terms, nothing herein is intended, nor will be deemed, to confer rights or remedies upon any third party.
              </li>
              <li>These Terms contain the entire agreement between you and us regarding the use of the Site, and supersede any prior agreement between you and us on such subject matter. The parties acknowledge that no reliance is placed on
                any representation made but not expressly contained in these Terms.
              </li>
              <li>Any failure on Hellopeter's part to exercise or enforce any right or provision of these Terms does not constitute a waiver of such right or provision. The failure of either party to exercise in any respect any right
                provided for herein shall not be deemed a waiver of any further rights hereunder.
              </li>
              <li>Except as expressly provided to the contrary herein, each paragraph, clause, term, and provision of these Terms and any portion thereof shall be considered severable and if, for any reason any part of these Terms is held
                to be invalid, contrary to, or in conflict with any applicable present or future law, statute or regulation (including, without limitation, the CPA to the extent applicable) or in terms of a final, binding judgment issued by
                any Court, it shall not impair the operation of, or have any other effect upon, such other portions of these Terms as may remain otherwise intelligible, which remaining provisions shall continue to be given full force and
                effect and bind the parties hereto.
              </li>
              <li>No term or condition of these Terms is intended to breach any peremptory provisions of the CPA to the extent applicable ("Prohibited Provision"). Any breach of any such Prohibited Provision shall be governed by the
                provisions of the preceding sub-clause <em>mutatis mutandis</em>.
              </li>
              <li>These Terms, and any rights or obligations hereunder, are not assignable, transferable or sub-licensable by you except with Hellopeter's prior written consent, but may be assigned or transferred by us without restriction.
                Any attempted assignment by you shall violate these Terms and be void.
              </li>
              <li>The clause headings in these Terms are for convenience only and have no legal or contractual effect.
              </li>
            </ol>
          </li>

        </ol>
        <h4 class="back-to-top has-text-right"><a @click.prevent="backToTop">BACK TO TOP</a></h4>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LegalLegal',
  metaInfo () {
    return {
      title: 'Hellopeter.com | Legal',
      meta: [{name: 'ROBOTS', content: 'NOINDEX, FOLLOW'}]
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Legal',
      brandName: '',
      industryName: ''
    })
    window.prerenderReady = true
  },
  methods: {
    backToTop () {
      window.scrollTo(0, 0)
      console.log('Back to top')
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.legal-columns {
  max-width: 1125px;
  color: #58595B;
  margin: 3rem auto 2rem auto;
}

.legal-columns > .column:first-child {
  background-color: #F5F5F5;
}

.legal-columns > .column {
  padding-top: 0;
}

.legal-columns > .column:nth-child(2) {
  padding-left: 4rem;
  padding-right: 0;
}

.legal-container {
  margin-top: 8rem;
}

.legal-container > h1, .legal-container > h3, .legal-container > p {
  max-width: 1125px;
  color: #58595B;
  margin: 0 auto 1rem auto;
}

.legal-container > h3 {
  font-size: 1.3rem;
}

.legal-container > .menu-links {
  max-width: 1125px;
  color: #58595B;
  margin: 2rem auto 1rem auto !important;
}

.legal-container > .menu-links > a {
  font-size: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
  color: #58595B;
  border-right: 1px solid #58595B;
}

.legal-container > .menu-links > a:last-child {
  padding-right: 0;
  border: none;
}

.legal-container > .menu-links > a:first-child {
  padding-left: 0;
}

.legal-menu {
  color: #666;
  padding: 3rem 2rem;
}

.legal-menu li {
  margin-bottom: 1.2rem;
  font-size: 0.8rem;
}

.legal-menu li > a, .legal-menu li > a:visited {
  text-decoration: none;
  color: #666;
}

.legal-menu li > a:hover {
  text-decoration: underline;
}

.legal-content a {
  color: map-get($colors, 'blue-v2');
}

.legal-content h1 {
  text-align: left;
  font-size: 20px;
  font-weight: normal;
}

.legal-content p {
  font-size: 14px;
  font-weight: normal;
  text-align: justify;
}

.legal-content li {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
}

.legal-content ol {
  counter-reset: item;
  padding-left: 30px;
  text-align: justify;
}

.legal-content ol li::before {
  content: counters(item, ".", decimal) ". ";
  counter-increment: item;
}

.legal-content ol > li {
  color: map-get($colors, 'blue-dark');
  font-weight: bold;
  text-align: left;
  font-size: 20px;
  text-transform: uppercase;
}

.legal-content ol > li > ol > li {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
  font-weight: normal;
  color: #666;
  text-transform: none;
}

.legal-head > span {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
  font-weight: normal;
  color: #666;
  text-transform: none;
}

.active-menu {
  color: map-get($colors, 'blue-v2') !important;
}

.back-to-top > a, .back-to-top > a:visited, .back-to-top > a:hover {
  margin-top: 4rem;
  color: map-get($colors, 'blue-v2');
  text-decoration: underline;
  font-size: 0.75rem !important;
}

@media screen and (max-width: 1024px) {
  .legal-columns {
    max-width: 95%;
  }

  .legal-columns > .column:nth-child(2) {
    padding-left: 2rem;
    padding-right: 0;
  }
}

@media screen and (max-width: 767px) {
  .legal-columns {
    width: 100%;
    max-width: 100%;
    margin: 4rem 0 2rem 0;
  }

  .legal-columns > .column:first-child {
    padding-top: 2rem;
    padding-bottom: 0;
  }

  .legal-columns > .column:nth-child(2) {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 2rem;
  }

  .legal-container > h1, .legal-container > h3, .legal-container > p, .legal-container > .menu-links {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .legal-container > .menu-links > a {
    font-size: 0.8rem;
    padding-right: 0;
    padding-left: 0;
    border-right: none;
    display: block;
    width: 100%;
    margin-bottom: 0.5rem;
    text-decoration: underline;
  }

  .legal-content > ol {
    padding-left: 0 !important;
  }

  .legal-content li, .legal-content p, .legal-content span {
    font-size: 0.8rem !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/legal/Legal.vue